/**
 * @file: screens.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { PlateNoScreen } from '@euler/app/flows/common/PlateNoScreen';
import { ServiceAgentSelectorScreen } from '@euler/app/flows/order/pages/ServiceAgentSelectorScreen';
import { VehicleBrandSelectorScreen } from '@euler/app/flows/order/pages/VehicleBrandSelectorScreen';
import { AdvancedSearchPage } from '@euler/app/flows/search/pages/advanced-search';
import { FastSearchPage } from '@euler/app/flows/search/pages/quick-search';
import { OrderSearchResultsPage } from '@euler/app/flows/search/pages/results';
import { ScreenToParams } from '@euler/functions/spreadScreens';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';

export const orderSearchScreens = {
  _index: FastSearchPage,
  _advancedSearch: AdvancedSearchPage,
  _results: OrderSearchResultsPage,
  _serviceAgentSelector: ServiceAgentSelectorScreen,
  _vehicleBrandSelector: VehicleBrandSelectorScreen,
  _plate: PlateNoScreen,
};

export type OrderSearchNavParams = ScreenToParams<typeof orderSearchScreens>;

export type OrderSearchNavigation = StackNavigationProp<OrderSearchNavParams>;

export const useOrderSearchNavigation = () =>
  useNavigation<OrderSearchNavigation>();
